import { SupabaseClient } from "@supabase/supabase-js";
import { SiteNotification } from "@/app/types/siteNotification";

/**
 * Fetch all active site notifications ordered by creation date.
 *
 * @param client - Supabase client
 * @returns Array of active site notifications
 */
export async function getActiveSiteNotifications(
  client: SupabaseClient,
): Promise<SiteNotification[]> {
  const { data, error } = await client
    .from("site_notifications")
    .select("id, message, state, created_at, updated_at")
    .eq("state", "active")
    .order("created_at", { ascending: false });

  if (error) {
    throw new Error(`Error fetching site notifications: ${error.message}`);
  }

  return (data || []) as SiteNotification[];
}
